import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ToastComponent } from '../shared/toast/toast.component';
import { AuthService } from '../services/auth.service';
import { ee } from '../shared/constants';
import { removeTooltipElement } from '../shared/functions';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  standalone: false
})
export class LoginComponent implements OnInit, OnDestroy {
  private auth = inject(AuthService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  toast = inject(ToastComponent);


  currentContent = 'login';
  menuItems = [
    { name: 'Login', link: 'login', icon: 'sign-in' },
    { name: 'Forgot password', link: 'forgot-password', icon: 'question-circle' },
  ];

  ngOnInit(): void {
    ee.on('changeContent', (data: string) => this.currentContent = data);
    if (this.auth.loggedIn) {
      this.router.navigate(['/']);
      return;
    }
    this.showVerifiedEmailMessage();
  }

  ngOnDestroy(): void {
    ee.off('changeContent', () => {});
    removeTooltipElement();
  }

  showVerifiedEmailMessage(): void {
    const verifiedQueryParam = this.route.snapshot.queryParamMap.get('verified');
    if (verifiedQueryParam) {
      this.toast.setMessage('Account successfully verified!', 'success');
    }
  }

}
